<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Jonnie Hyde is a PhD psychologist living in SW Washington, where she founded and was executive director of a large community mental health center. After retiring in 2017, she decided to pursue her lifelong goal of writing a novel. And since she has been a close follower of climate science and climate change since reading Paul Ehrlic’s <em>The Population Bomb</em> in 1970, she decided to bring these two passions together in her novel, <em>Irrevocable Acts.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7b00a57a